import { render } from "./VODitem.vue?vue&type=template&id=721626c2"
import script from "./VODitem.vue?vue&type=script&lang=js"
export * from "./VODitem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__